import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import SEO, { BreadcrumbSchema } from "../components/SEO";
import { FadeUp } from "../components/Motion";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, LICENSES } from "../lib/content";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact BCPeabody | Tampa | (813) 919-5548"
        description={`Call ${CONTACT.phone} or send a message. Tampa general contractor serving Tampa Bay, Florida and federal clients nationwide.`}
        path="/contact"
      />
      <BreadcrumbSchema items={[{ name: "Home", url: "https://bcpeabody.com/" }, { name: "Contact", url: "https://bcpeabody.com/contact" }]} />
      <Nav />

      <section className="pt-32 pb-10 bg-cream-light">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <div className="text-[11px] tracking-[0.18em] uppercase mb-5 text-copper">Get In Touch</div>
          <h1 className="font-serif font-medium text-ink tracking-tight leading-[1.05]" style={{ fontSize: "clamp(34px, 5vw, 60px)" }}>
            Contact BCPeabody
          </h1>
          <p className="mt-6 text-ink/75 max-w-2xl" style={{ fontSize: 17 }}>
            Tell us about your project. We respond within one business day.
          </p>
        </div>
      </section>

      <section className="bg-cream-light pb-24">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-4 space-y-7 text-sm">
            <FadeUp>
              <div>
                <div className="text-[11px] tracking-[0.18em] uppercase mb-2 text-copper">Phone</div>
                <a href={CONTACT.phoneHref} className="font-serif text-2xl text-ink hover:text-copper flex items-center gap-3">
                  <Phone size={18} className="text-copper" /> {CONTACT.phone}
                </a>
              </div>
            </FadeUp>
            <FadeUp delay={60}>
              <div>
                <div className="text-[11px] tracking-[0.18em] uppercase mb-2 text-copper">Email</div>
                <a href={`mailto:${CONTACT.email}`} className="font-serif text-lg text-ink hover:text-copper flex items-center gap-3 break-all">
                  <Mail size={18} className="text-copper shrink-0" /> {CONTACT.email}
                </a>
              </div>
            </FadeUp>
            <FadeUp delay={120}>
              <div>
                <div className="text-[11px] tracking-[0.18em] uppercase mb-2 text-copper">Location</div>
                <p className="font-serif text-lg text-ink flex items-center gap-3">
                  <MapPin size={18} className="text-copper" /> {CONTACT.location}
                </p>
              </div>
            </FadeUp>
            <FadeUp delay={160}>
              <div>
                <div className="text-[11px] tracking-[0.18em] uppercase mb-2 text-copper">Mailing address</div>
                <address className="not-italic text-ink/80 leading-relaxed">
                  {CONTACT.mailingLines.map((l) => <div key={l}>{l}</div>)}
                </address>
              </div>
            </FadeUp>
            <div>
              <div className="text-[11px] tracking-[0.18em] uppercase mb-2 text-copper">Licenses</div>
              <div className="text-ink/80 leading-relaxed">
                CGC1515086 · CFC1429871 · PE 63780 (Robert M. Carpenter) · {LICENSES.pairedLabel}
              </div>
            </div>
            <div>
              <div className="text-[11px] tracking-[0.18em] uppercase mb-2 text-copper">Hours</div>
              <p className="text-ink/80">Monday to Friday, 8 AM to 6 PM</p>
            </div>
              <div>
                <div className="text-[11px] tracking-[0.18em] uppercase mb-2 text-copper">Service area</div>
                <p className="text-ink/80 leading-relaxed">
                  Residential across the greater Tampa Bay region and Gulf Coast. Commercial across Florida. Federal, recovery and expert witness nationwide.
                </p>
              </div>
          </div>

          <div className="col-span-12 md:col-span-7 md:col-start-6">
            <FadeUp>
              <div className="bg-cream p-8 md:p-10 border-t-2 border-copper">
                <h2 className="font-serif text-2xl md:text-3xl text-ink mb-4 tracking-tight">Tell us about your project.</h2>
                <p className="text-ink/70 text-sm leading-relaxed mb-6">
                  For attorneys: expert witness inquiries are handled confidentially. Initial communications may be used to complete a conflict check before engagement details are discussed.
                </p>
                <ContactForm />
              </div>
            </FadeUp>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
